// Client-side mirror of the server's access rules (server/src/lib/access.js).
// The SERVER is the source of truth and enforces every action; this only hides controls a member
// can't use, so the UI matches their capabilities. Keep the two files in sync.
export const CAP = {
  APPROVE: 'approve',
  MANAGE_TEAM: 'manage_team',
  MANAGE_SETTINGS: 'manage_settings',
  MANAGE_CLIENTS: 'manage_clients',
  CREATE_ORDER: 'create_order',
  MANAGE_PAYMENTS: 'manage_payments',
  MANAGE_SHIPPING: 'manage_shipping',
  MANAGE_LOOKBOOKS: 'manage_lookbooks',
  MANAGE_MARKETING: 'manage_marketing',
};

const MANAGER_CAPS = [
  CAP.MANAGE_CLIENTS,
  CAP.CREATE_ORDER,
  CAP.MANAGE_PAYMENTS,
  CAP.MANAGE_SHIPPING,
  CAP.MANAGE_LOOKBOOKS,
  CAP.MANAGE_MARKETING,
];

const CAPS_BY_LEVEL = {
  ADMIN: Object.values(CAP),
  MANAGER: MANAGER_CAPS,
  VIEWER: [],
};

/** Does this user hold a capability? Only INTERNAL_STAFF carry capability tiers. */
export function can(user, cap) {
  if (!user || user.role !== 'INTERNAL_STAFF') return false;
  return (CAPS_BY_LEVEL[user.accessLevel] || []).includes(cap);
}

/**
 * Store codes this user may see/act on (mirror of the server's allowedStoreCodes).
 * INTERNAL_STAFF + REP → per storeAccess; anyone else → null ("not store-scoped").
 * Use it to hide store pickers a member has no choice about.
 */
export function allowedStoreCodes(user) {
  if (!user || (user.role !== 'INTERNAL_STAFF' && user.role !== 'REP')) return null;
  if (user.storeAccess === 'A') return ['A'];
  if (user.storeAccess === 'B') return ['B'];
  return ['A', 'B'];
}
